/**
 * @module toType
 */

/**
 * Convenience function to find and return the type of the specified object.
 * This function acts as an alternative to using the built-in `typeof`.
 *
 * @param {*} obj - The object for which to check the type.
 *
 * @returns {string} The type value.
 *
 * @see {@link https://stackoverflow.com/a/7390612}.
 */
function toType(obj) {
  const type = {}.toString
    .call(obj)
    .match(/\s([a-zA-Z]+)/)[1]
    .toLowerCase();
  return type === 'array' ? 'object' : type;
}

module.exports = {
  toType,
};
